export default {
  '847ef1be8c5c20ddf71c2b8156c22dbf': '提示',
  c694fdd9779381317352b6e1ed03267d: '暫不解綁',
  f510e72ea1ba87e3f7ed5600830272cc: '解綁賬號',
  '4f4309e2c1e3390d19259e3523ec04d8':
    '根據國家政策要求，發往台灣地區的快件需填寫證件號碼，請您補充填寫',
  d4a6b6cff9ce229a3caa981e66786528: '取消',
  d32275e7d418ae7ed2945adedc040ec7: '去補充',
  '596ccc86ae49ea544182222542c3b54f': '抱歉，價格已發生變化!',
  b4ae53838c0e0f8eb3a3497fe4a8e8a9: '抱歉，創建訂單失敗！',
  '381b884bbcb1d33eccd70e3b19ee595a': '系統錯誤',
  '6fad4422b2105c2f7e5382aa64a49e6a': '內購商品已失效',
  '6fad4422b2105c2f7e5382aa64a49e6b': '支付成功'
};
